import React from 'react';
import moment from 'moment';
import { IPage } from '../../../../interfaces/models/models/paginated-response.model';
import { IPaginationPayload } from '../../../../interfaces/shared/IPaginationPayload';
import { onFormatCashoutItemStatus } from '../../../../utils/constants/format-order-statuses';
import Table from '../../../../shared/table';

const tableColumns = ['Item ID', 'Category', 'Price', 'Status', 'Transaction Date', 'Seller ID', 'Actions']
const tableKeys = ['_id', 'category', 'price', 'status', 'transactionDate', 'sellerId']

interface ICashoutsTable {
    rows: any;
    paginationData?: IPage;
    cashoutsLoading: boolean;
    accessControl?: any;
    actions?: any;
    onSeeDetails: (item: any) => void;
    setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const CashoutItemsTable = ({
    rows,
    paginationData,
    cashoutsLoading,
    accessControl,
    actions,
    onSeeDetails,
    setPaginationState,
}: ICashoutsTable) => {
    return (
        <Table
            columns={tableColumns}
            paginationData={paginationData}
            setPaginationState={setPaginationState}>
            {cashoutsLoading ?
                <>
                    {[...Array(10)].map((x, i) => {
                        return (
                            <tr key={i}>
                                {tableColumns?.map(element => {
                                    return (
                                        <td key={element} className='td-1 !min-w-[100%] text-center py-5'><span></span></td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </>
                : <>
                    {rows?.length > 0 && rows?.map((row: any, idx: number) => {
                        return (
                            <tr key={idx} className='bg-white border-b hover:bg-gray-50'>
                                {tableKeys?.length > 0 && tableKeys?.map((key, index) => {
                                        let value = row?.[key]
                                        let item = null
                                        if (key === 'status') {
                                            value = onFormatCashoutItemStatus(row?.[key])?.name
                                            const color = onFormatCashoutItemStatus(row?.[key])?.color
                                            item = color && <div className={`${color} flex flex-row justify-center text-center text-red px-1 min-w-[150px] text-black text-sm py-1 font-medium rounded-2xl`}>{value}</div>
                                        }
                                        if (key === 'transactionDate') {
                                            value = moment(row?.purchaseDate || row?.createdAt).format('DD-MM-YYYY, HH:mm')
                                        }
                                        return (
                                            <td
                                                key={index}
                                                className={'px-6 py-4'}>
                                                {item || value}
                                            </td>
                                        )
                                })}
                                <td className='px-6 py-4 min-w-[120px]'>
                                    <div className='flex flex-row justify-around'>
                                        <div data-qa={'see-item-details'} onClick={() => (!accessControl || actions?.['See Item Details']) && onSeeDetails(row)}>
                                            <img title={'View Details'} alt='item details' src={'/assets/table-actions/visibility.svg'} className={'h-[14px] object-contain cursor-pointer mr-2'} />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                </>
            }
        </Table>
    )
}

export default CashoutItemsTable;